import React, {FC} from 'react';

import Counter from '../../Counter';
import {useStats} from '../../data';

/** 数据统计区：4 个计数器（卖家规模、处理量、覆盖地区、累计生成量），入场 transition-delay 交错 */
const Stats: FC = () => {
  const stats = useStats();

  return (
    <section className="relative py-20 lg:py-24 bg-slate-50">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat) => (
            <div className="text-center scroll-reveal" key={stat.key} style={{transitionDelay: stat.transitionDelay}}>
              <Counter target={stat.target} />
              <div className="text-indigo-600 text-lg font-semibold mt-1">{stat.suffix}</div>
              <div className="text-sm text-slate-500 mt-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
